// ============================================
// Admin API Service
// ============================================

import api from './api';

const adminService = {
    // ── Dashboard Stats ─────────────────────
    getStats: () => api.get('/admin/stats'),

    // ── Schools ─────────────────────────────
    getSchools: (params) => api.get('/admin/schools', { params }),
    getSchool: (id) => api.get(`/admin/schools/${id}`),
    createSchool: (data) => api.post('/admin/schools', data),
    updateSchool: (id, data) => api.put(`/admin/schools/${id}`, data),
    deleteSchool: (id) => api.delete(`/admin/schools/${id}`),

    // ── Children ────────────────────────────
    getChildren: (params) => api.get('/admin/children', { params }),
    getChild: (id) => api.get(`/admin/children/${id}`),
    createChild: (data) => api.post('/admin/children', data),
    updateChild: (id, data) => api.put(`/admin/children/${id}`, data),
    deleteChild: (id) => api.delete(`/admin/children/${id}`),

    // ── Routes ──────────────────────────────
    getRoutes: (params) => api.get('/admin/routes', { params }),
    getRoute: (id) => api.get(`/admin/routes/${id}`),
    createRoute: (data) => api.post('/admin/routes', data),
    updateRoute: (id, data) => api.put(`/admin/routes/${id}`, data),
    deleteRoute: (id) => api.delete(`/admin/routes/${id}`),

    // ── Vehicles ────────────────────────────
    getVehicles: (params) => api.get('/admin/vehicles', { params }),
    getVehicle: (id) => api.get(`/admin/vehicles/${id}`),
    createVehicle: (data) => api.post('/admin/vehicles', data),
    updateVehicle: (id, data) => api.put(`/admin/vehicles/${id}`, data),
    deleteVehicle: (id) => api.delete(`/admin/vehicles/${id}`),
    assignDriverToVehicle: (id, driverId) => api.patch(`/admin/vehicles/${id}/assign-driver`, { driverId }),

    // ── Drivers ─────────────────────────────
    getDrivers: (params) => api.get('/admin/drivers', { params }),
    getDriver: (id) => api.get(`/admin/drivers/${id}`),
    toggleDriverBlock: (id, block, force = false) => api.patch(`/admin/drivers/${id}/block`, { block, force }),
    toggleDriverStatus: (id, isActive) => api.patch(`/admin/drivers/${id}/status`, { isActive }),
    assignRouteToDriver: (id, routeId, options = {}) => api.patch(`/admin/drivers/${id}/assign-route`, typeof routeId === 'object' && routeId !== null ? routeId : { routeId, ...options }),
    assignVehicleToDriver: (id, payload) => api.patch(`/admin/drivers/${id}/assign-vehicle`, typeof payload === 'object' && payload !== null ? payload : { vehicleId: payload }),
    verifyDocument: (id, type, status, reason) => api.patch(`/admin/drivers/${id}/verify-document`, { type, status, reason }),
    deleteDocument: (id, type) => api.delete(`/admin/drivers/${id}/delete-document`, { data: { type } }),
    deleteDriver: (id) => api.delete(`/admin/drivers/${id}`),
    // ── PAs ─────────────────────────────────
    getPAs: (params) => api.get('/admin/pas', { params }),
    getPA: (id) => api.get(`/admin/pas/${id}`),
    verifyPADocument: (id, type, status, reason, expiryDate) => api.patch(`/admin/pas/${id}/verify-document`, { type, status, reason, expiryDate }),
    deletePADocument: (id, type) => api.delete(`/admin/pas/${id}/delete-document`, { data: { type } }),
    deletePA: (id) => api.delete(`/admin/pas/${id}`),
    // ── Jobs ────────────────────────────────
    getJobs: () => api.get('/admin/jobs'),
    createJob: (data) => api.post('/admin/jobs', data),
    updateJob: (id, data) => api.put(`/admin/jobs/${id}`, data),
    deleteJob: (id) => api.delete(`/admin/jobs/${id}`),
    assignJobToDriver: (id, driverId) => api.patch(`/admin/jobs/${id}/assign-driver`, { driverId }),
    unassignJob: (id) => api.patch(`/admin/jobs/${id}/unassign-driver`),

    // ── Settings & Profile ──────────────────
    getSettings: () => api.get('/admin/settings'),
    updateSettings: (data) => api.put('/admin/settings', data),
    updateProfile: (data) => api.put('/admin/profile', data),
};

export default adminService;
